import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import './Spinner.scss';

const Spinner = React.memo(({modal: isModal}) => (
  <div className={`spinner ${isModal ? 'spinner__modal' : ''}`}>
    <CircularProgress/>
  </div>
))

export default Spinner;
